import { render, staticRenderFns } from "./PositionManage.vue?vue&type=template&id=2b496c7f&"
import script from "./PositionManage.vue?vue&type=script&lang=js&"
export * from "./PositionManage.vue?vue&type=script&lang=js&"
import style0 from "./PositionManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports